// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zPhC","textarea":"styles_textarea__2Nysw"};